var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "room-attendance-btn",
      class: { isOpenControlMenu: _vm.isOpenControlMenu && _vm.isMobile },
      on: { click: _vm.regAttend },
    },
    [
      _c("img", {
        staticClass: "ico-check-attendance",
        attrs: { src: require("@/assets/images/camstudy/ico_check_white.svg") },
      }),
      _vm._v(" " + _vm._s(_vm.$t("camstudy.attendance.checkIn")) + " "),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }